import { faInstagram, faTiktok, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { AppsNavigationItem } from "./../shared/dto/NavigationItem";
import { AppPlansDto } from "../shared/dto/AppPlansDto";
import { getGenerateRandomInt } from "../shared/helpers/NumberHelper";
import { NavigationItemTypeEnum } from "../shared/helpers/NavigationItemTypeEnum";
import { RoutesEnum } from "../routes/RoutesEnum";
import { faCoins, faDice, faImage, faListNumeric, faRandom, faSearch, faX } from "@fortawesome/free-solid-svg-icons";

export const version = "1.0.2";
export const isDevelopmentEnvironment = (process.env.NODE_ENV === 'development');
export const isProductionEnvironment = (process.env.NODE_ENV === 'production');
export const isTestComponentAlwaysDisplay = (process.env.NODE_ENV === 'development') && false;
export const isMaintenance = (process.env.NODE_ENV === 'development') ? false : true;
const isSimulateData = (process.env.NODE_ENV === 'development') ? false : false;
export const isDevelopmentReactStrictMode = false;
export const allowPwaOnLocalhost = false;
//if maintenance and pass this parameter, you will be able to access the app
export const forceAppShowApiKey = "true";

export const minParticipantsCount: number = 3;
export const maxParticipantsCount: number = 500000;
export const paginationSize = 15;

/*
used in fetching campaign data (comments, etc.) via API
*/
export const apiNoFetchExceptionDelayRequestsMs = 1000;
export const apiNoFetchMaxRetry = 5;
/*
used in fetching general data via API
*/
export const defaultWaitBetweenRequestsMs = 2000;
export const defaultMaxRetry = 20;

export const MainCategoryNames = {
    BusinessesForSale: "Businesses For Sale",
    Products: "Products",
    Services: "Services",
    Startups: "Startups"
}

export const appPlans: AppPlansDto[] = [
    {
        name: "Free",
        price: 0,
        features: [
            { enabled: true, name: "Basic support" },
            { enabled: true, name: "30 days listing your business in global map" },

            { enabled: false, name: "Priority support" },
            { enabled: false, name: "Unlimited time listing listing your business in global map" },
            { enabled: false, name: "Blue Checkmark / Verified" },
            { enabled: false, name: "Receive and send private DM's" },
        ],
        highlight: false,
        button: false,
    },
    {
        name: "Business",
        price: 14.49,
        features: [
            { enabled: true, name: "Priority support" },
            { enabled: true, name: "Unlimited time listing your business in global map" },
            { enabled: true, name: "Blue Checkmark / Verified" },
            { enabled: true, name: "Receive and send private DM's" },
        ],
        highlight: true,
        button: true,
    }
];

export const navigationAppsItems: AppsNavigationItem[] = [
    {
        Header: {
            Name: "Giveaways / Promotions",
            Items: [
                {
                    Name: "Instagram Giveaway",
                    Icon: faInstagram,
                    NavigationItemType: NavigationItemTypeEnum.App,
                    TextColor: "text-instagram",
                    Route: RoutesEnum.APP_INSTAGRAM_URL,
                },
                {
                    Name: "TikTok Giveaway",
                    Icon: faTiktok,
                    NavigationItemType: NavigationItemTypeEnum.App,
                    TextColor: "text-tiktok",
                    Route: RoutesEnum.APP_TIKTOK_URL,
                },
                {
                    Name: "Youtube Giveaway",
                    Icon: faYoutube,
                    NavigationItemType: NavigationItemTypeEnum.App,
                    TextColor: "text-youtube",
                    Route: RoutesEnum.APP_YOUTUBE_URL,
                },
                {
                    Name: "Twitter / X Giveaway",
                    Icon: faX,
                    NavigationItemType: NavigationItemTypeEnum.App,
                    TextColor: "text-twitter",
                    Route: RoutesEnum.APP_TWITTER_URL,
                },
                {
                    Name: "Random Name Winner Giveaway",
                    Icon: faListNumeric,
                    NavigationItemType: NavigationItemTypeEnum.App,
                    TextColor: "text-randomNameWinner",
                    Route: RoutesEnum.APP_RANDOM_NAME_WINNERS,
                },
            ]
        }
    },
    {
        Header: {
            Name: "Tools",
            Items: [
                {
                    Name: "Search Giveaway by Code",
                    Icon: faSearch,
                    NavigationItemType: NavigationItemTypeEnum.App,
                    TextColor: "text-secondary",
                    Route: RoutesEnum.CAMPAIGN_SEARCH_BY_CODE,
                },
                {
                    Name: "Create Giveaway Image",
                    Icon: faImage,
                    NavigationItemType: NavigationItemTypeEnum.App,
                    TextColor: "text-numbers",
                    Route: RoutesEnum.APP_CREATE_GIVEAWAY_IMAGE,
                },
            ]
        }
    },
    {
        Header: {
            Name: "Random",
            Items: [
                {
                    Name: "Roll Dice",
                    Icon: faDice,
                    NavigationItemType: NavigationItemTypeEnum.App,
                    TextColor: "text-secondary",
                    Route: RoutesEnum.APP_ROLL_DICE,
                },
                {
                    Name: "Random Numbers",
                    Icon: faRandom,
                    NavigationItemType: NavigationItemTypeEnum.App,
                    TextColor: "text-numbers",
                    Route: RoutesEnum.APP_RANDOM_NUMBERS,
                },
                {
                    Name: "Flip a Coin",
                    Icon: faCoins,
                    NavigationItemType: NavigationItemTypeEnum.App,
                    TextColor: "text-coins",
                    Route: RoutesEnum.APP_FLIP_COIN,
                },
            ]
        }
    }
];